import * as React from 'react';

export function isNumberKey(event: React.KeyboardEvent) {
  const charCode = event.which ? event.which : event.keyCode;
  if (event.key === '.') return true;
  if (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105) && charCode !== 110)
    return false;
  return true;
}

export function preventNonNumberKey(event: React.KeyboardEvent) {
  if (!isNumberKey(event)) {
    event.preventDefault();
  }
}

export function roundToPrecision(value: string, precision?: number) {
  return parseFloat(value).toFixed(precision);
}

export function calculatePrecision(value: string | number) {
  const groups = /[1-9]([0]+$)|\.([0-9]*)/.exec(String(value));
  if (!groups) {
    return 0;
  }
  if (groups[1]) {
    return -groups[1].length;
  }
  if (groups[2]) {
    return groups[2].length;
  }
  return 0;
}
